import './style.css';
import { Game } from './game/Game';
import { DEFAULT_SEED, parseSeed } from './sim/seed';

const container = document.querySelector<HTMLDivElement>('#app');
if (!container) {
  throw new Error('#app container missing from index.html');
}

const rawSeed = new URL(window.location.href).searchParams.get('seed');
const unsetSeed = rawSeed === null || rawSeed === '-';
const seed = unsetSeed ? DEFAULT_SEED : parseSeed(rawSeed);
const game = seed === null ? null : new Game(container, seed);
if (game) {
  void game.start();
} else {
  const message = document.createElement('p');
  message.textContent = 'Virheellinen seed. Käytä kokonaislukua 0–4294967295.';
  const link = document.createElement('a');
  const url = new URL(window.location.href);
  url.searchParams.delete('seed');
  link.href = url.href;
  link.textContent = 'Avaa peli oletusseedillä (0)';
  container.append(message, link);
}

declare global {
  interface Window {
    /** Dev-only handle for poking at gameplay values from the console. */
    laniaamu?: Game;
  }
}

if (import.meta.env.DEV && game) {
  window.laniaamu = game;
}

// Vite HMR: tear the old game down so we do not stack renderers or listeners.
if (import.meta.hot) {
  import.meta.hot.dispose(() => game?.dispose());
}
